/* src/app/components/control-module/timeline/timeline.component.css */
.date {
  visibility: hidden;
}
h3 {
  color: var(--navy-600);
}
.date {
  visibility: hidden;
}
.programmation {
  color: var(--success);
  border-radius: 0px 0px 5px 5px;
}
.evaluation {
  color: var(--warning);
  border-radius: 0px 0px 5px 5px;
}
.execution {
  color: rgb(117, 113, 241);
  border-radius: 0px 0px 5px 5px;
}
.draft {
  color: var(--fg-3);
  border-radius: 0px 0px 5px 5px;
}
.approved {
  color: var(--success);
  border-radius: 0px 0px 5px 5px;
}
.timeline-img > p {
  color: var(--fg-1) !important;
}
.timeline-content {
  min-height: 5em !important;
}
.timeline-item:nth-child(even) .timeline-content {
  float: right;
  padding: 5px 30px 10px 30px;
}
/*# sourceMappingURL=timeline.component.css.map */
